import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { HeaderComponent } from './header/header.component';
import { AddressComponent } from './address/address.component';
import { ButtonComponent } from './button/button.component';
import { InputGeneralComponent } from './input-general/input-general.component';
import { KonfirmasiHapusComponent } from './state/konfirmasi-hapus/konfirmasi-hapus.component';
import { PreviewImageNotokenComponent } from './preview-image-notoken/preview-image-notoken.component';
import { PreviewPhotoLaporanComponent } from './preview-photo-laporan/preview-photo-laporan.component';
// import { CalendarModule } from 'ion2-calendar';

@NgModule({
  declarations: [
    HeaderComponent,
    AddressComponent,
    ButtonComponent,
    InputGeneralComponent,
    KonfirmasiHapusComponent,
    PreviewImageNotokenComponent,
    PreviewPhotoLaporanComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    // CalendarModule
  ],
  exports: [
    HeaderComponent,
    AddressComponent,
    ButtonComponent,
    InputGeneralComponent,
    KonfirmasiHapusComponent,
    PreviewImageNotokenComponent,
    PreviewPhotoLaporanComponent
  ]
})
export class SharedModule { }
